<template>
  <el-select
    :value="serviceGroupId"
    :disabled="disabled"
    class="serviceGroup-selector"
    filterable
    placeholder="เลือกทั้งหมด"
    clearable
    @input="handleChangeServiceGroup"
  >
    <el-option
      v-for="item in serviceGroupOptions"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    >
      <div class="serviceGroup-option">
        <img :src="item.iconUrl" class="icon" />
        <div class="name">{{ item.name }}</div>
      </div>
    </el-option>
  </el-select>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { Select, Option } from "element-ui";

export default {
  components: {
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const serviceGroups = [];

    return {
      serviceGroups
    };
  },
  computed: {
    serviceGroupOptions() {
      return this.serviceGroups;
    },
    serviceGroupId() {
      if (!this.value) {
        return null;
      }

      return this.value.id;
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupServiceGroups();
    },
    async setupServiceGroups() {
      this.serviceGroups = await this.fetchServiceGroups();
    },
    async fetchServiceGroups() {
      const response = await baanRueJaiClient.admin.subscriptions.serviceCategories.list();

      return response.data.result.map(item => ({
          id: item.id,
          name: item.name,
          iconUrl: item.icon,
          serviceCount: item.service_ids.length
        }));
    },
    handleChangeServiceGroup(serviceGroupId) {
      const serviceGroup = this.serviceGroups.find(
        sg => sg.id === serviceGroupId
      );

      this.$emit("input", serviceGroup);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.serviceGroup-selector {
  width: 100%;
}

.serviceGroup-option {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  > .icon {
    margin-right: 20px;

    border-radius: $border-radius;
    width: 24px;
    height: 24px;
  }
}
</style>
